import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

const CustomPhoneInput = ({
    defaultCountry,
    value,
    onChange,
    disabled,
    style,
}) => {
    return (
        <PhoneInput
            defaultCountry={defaultCountry || "az"}
            value={value}
            onChange={onChange}
            disabled={disabled}
            style={style}
            name="phone"
            inputProps={{
                autoComplete: 'off',
                autoCorrect: 'off',
                autoCapitalize: 'off',
                spellCheck: 'false',
                inputMode: 'numeric',
            }}
        />
    );
};

export default CustomPhoneInput;
